/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Lucky Cosmos: include blog articles + pages in the predictive search
  // dropdown. Broadcast hardcodes the predictive-search request to products
  // only inside theme.js (which must not be edited), so we patch the request
  // at runtime here.
  var nativeFetch = window.fetch;
  window.fetch = function(input, init) {
    try {
      var url = (typeof input === 'string') ? input : (input && input.url);
      if (
        url &&
        url.indexOf('section_id=predictive-search') !== -1 &&
        url.indexOf('resources[type]') === -1 &&
        url.indexOf('resources%5Btype%5D') === -1
      ) {
        var patchedUrl = url.replace(
          '&section_id=predictive-search',
          '&resources[type]=product,collection,page,article&section_id=predictive-search'
        );
        if (typeof input === 'string') {
          input = patchedUrl;
        } else {
          input = new Request(patchedUrl, input);
        }
      }
    } catch (e) {}
    return nativeFetch.apply(this, [input, init]);
  };

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
